module.exports = __webpack_public_path__ + "static/media/UpdatedMetrics.ba5ffcf2.svg";